import { render, staticRenderFns } from "./RemotSimInfo.vue?vue&type=template&id=bd378f16&scoped=true"
import script from "./RemotSimInfo.vue?vue&type=script&lang=js"
export * from "./RemotSimInfo.vue?vue&type=script&lang=js"
import style0 from "./RemotSimInfo.vue?vue&type=style&index=0&id=bd378f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd378f16",
  null
  
)

export default component.exports